import { render, staticRenderFns } from "./new-password.vue?vue&type=template&id=02bb43a4&scoped=true&lang=pug"
import script from "./new-password.vue?vue&type=script&lang=ts"
export * from "./new-password.vue?vue&type=script&lang=ts"
import style0 from "./new-password.vue?vue&type=style&index=0&id=02bb43a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bb43a4",
  null
  
)

export default component.exports